import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const FormField = ({
  label,
  error,
  required,
  className,
  labelClassName,
  inputClassName,
  rightIcon,
  leftIcon,
  rightIconClassName,
  ...props
}) => {
  const hasIcon = rightIcon || leftIcon;
  const isDate = props.type === "date";

  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <Label className={labelClassName}>
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </Label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            {leftIcon}
          </div>
        )}
        <Input
          className={cn(
            error && "border-destructive",
            leftIcon && "pl-10",
            rightIcon && "pr-10",
            isDate && "dark:[color-scheme:dark] light:[color-scheme:light]",
            inputClassName,
          )}
          {...props}
        />
        {rightIcon && (
          <div
            className={cn(
              "absolute right-3 -translate-y-1/2 text-gray-400",
              rightIconClassName ?? "top-1/2",
            )}
          >
            {rightIcon}
          </div>
        )}
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
